import React from 'react';
import { BoldHighlight, NoteText } from './styledComponents';
import EmailLink from '../../app/onboarding/components/EmailLink';
import { EMME_SUPPORT_EMAIL } from '@/shared/constants/utility';

export const CREATE_PROFILE_STEP = 0;
export const SOCIALS_STEP = 1;
export const STYLING_SPECIALTY_STEP = 2;
export const STYLING_PREFERENCES_STEP = 3;
export const SHOWCASE_STEP = 4;
export const PAYMENT_STEP = 5;
export const READY_STEP = 6;

export const stylistOnboardingTitleTextOptions: { [key: number]: string } = {
  [CREATE_PROFILE_STEP]: 'CREATE \nYOUR PROFILE',
  [SOCIALS_STEP]: "LET'S GET TO KNOW YOU",
  [STYLING_SPECIALTY_STEP]: 'YOUR STYLING SWEET SPOT',
  [STYLING_PREFERENCES_STEP]: 'DEFINE YOUR STYLING PREFERENCES',
  [SHOWCASE_STEP]: "SHOW, DON'T TELL",
  [PAYMENT_STEP]: 'SET UP YOUR PAYMENT ACCOUNT',
  [READY_STEP]: "YOU'RE READY TO STYLE!",
};

export const stylistOnboardingDescriptionTextOptions: {
  [key: number]: React.ReactNode;
} = {
  [CREATE_PROFILE_STEP]: (
    <>
      Start by uploading a clear profile image of yourself and entering your
      full name. This will help clients recognize and trust you as their
      stylist.
    </>
  ),
  [SOCIALS_STEP]: (
    <>
      Give clients a peek behind the scenes—your experience, your approach. Keep
      it short, sharp, and you.
    </>
  ),
  [STYLING_SPECIALTY_STEP]: (
    <>
      What&apos;s your specialty? Choose the areas where you shine—these will be
      highlighted on your profile so clients can find their perfect match.
      {'\n\n'}Pick as many as you like!
    </>
  ),
  [STYLING_PREFERENCES_STEP]: (
    <>
      Your signature touch, front and center. Select the aesthetics you know
      best—these will help match you with clients looking for your expertise.
      {'\n\n'}No need to limit yourself—style has range, and so do you.
    </>
  ),
  [SHOWCASE_STEP]: (
    <>
      Give clients a peek into your styling world. Upload up to four images that
      showcase your aesthetic, techniques, or vibe. {'\n\n'}
      <NoteText>
        Pro Tip: Choose high-quality images that reflect your style. (Accepted
        formats: webp, jpeg, jpg, png, gif. At least one image required.)
      </NoteText>
    </>
  ),
  [PAYMENT_STEP]: (
    <>
      To receive payments for your styling sessions, you&apos;ll need to create
      a <BoldHighlight>Stripe account</BoldHighlight>. Just follow the steps to
      get set up—it only takes a few minutes. {'\n\n'}
      <NoteText>
        Need help? We&apos;ve got you—reach out at{' '}
        <EmailLink style={{ fontSize: 14 }}>{EMME_SUPPORT_EMAIL}</EmailLink>
      </NoteText>
    </>
  ),
  [READY_STEP]: (
    <>
      Clients can now discover your profile. Book sessions, build connections,
      and take your styling career to the next level.
    </>
  ),
} as const;

export const stylistOnboardingRequiredSteps = [
  CREATE_PROFILE_STEP,
  SOCIALS_STEP,
  STYLING_SPECIALTY_STEP,
  STYLING_PREFERENCES_STEP,
  SHOWCASE_STEP,
  PAYMENT_STEP,
];
